import { pageRoutes } from './routes';
export const routes = pageRoutes;